<template>
  <div class="sc__wrapper rounded-full overflow-hidden">
    <div id="gameContainer" class="sc__container"></div>
  </div>
</template>

<script>
import { ScratchCard, SCRATCH_TYPE } from "scratchcard-js";
import { mapState } from "pinia";
import { authStore } from "../stores/auth";

export default {
  name: "ScratchGame",
  components: {},
  data() {
    return {};
  },
  props: {
    promotionsById: {
      type: Object,
      default: () => ({}),
    },
    gameParticipation: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    const gameContainer = document.getElementById("gameContainer");
    const scratchCard = new ScratchCard(gameContainer, this.scratchOptions);
    scratchCard.canvas.addEventListener("scratch.move", async () => {
      let percent = scratchCard.getPercent();
      if (percent > this.percentToFinish) {
        this.$emit("scratchFinished");
      }
    });
    scratchCard.init();
  },
  methods: {},
  computed: {
    ...mapState(authStore, ["branding", "organization", "customerId"]),
    percentToFinish() {
      return 30;
    },
    scratchBackColor() {
      return this.branding.accentColor;
    },
    forwardImageSrc() {
      let rewardStampImageId = this.branding.rewardStampImageId;
      let backColor = this.scratchBackColor.replace("#", "");
      let iconColor = this.$utils.colorIsDark(this.scratchBackColor)
        ? "ffffff"
        : "000000";
      return `https://res.cloudinary.com/comebackapp/image/upload/f_auto,q_auto/h_384,w_384,c_fit,co_rgb:${backColor},e_colorize/l_${rewardStampImageId},h_200,w_200,co_rgb:${iconColor},e_colorize/fl_layer_apply/one_pixel`;
    },
    scratchOptions() {
      const gameContainer = document.getElementById("gameContainer");
      return {
        scratchType: SCRATCH_TYPE.LINE,
        containerWidth: gameContainer?.offsetWidth,
        containerHeight: 250,
        imageForwardSrc: this.forwardImageSrc,
        imageBackgroundSrc:
          "https://res.cloudinary.com/comebackapp/image/upload/f_auto,q_auto/h_384,w_384,c_fit/v1664623844/qy4cvwckohlhrjzilowr",
        htmlBackground: `<div style='background-color: ${this.$utils.darken(
          this.scratchBackColor,
          30
        )}' class='h-[250px] flex flex-row items-center justify-center'><div class='text-xl text-contrast text-center uppercase font-bold'>${
          this.gameParticipation.couponPromotionId
            ? this.promotionsById[this.gameParticipation.couponPromotionId]
                ?.name
            : this.$t("no-prize")
        }</div></div>`,
        clearZoneRadius: 20,
        nPoints: 0,
        pointSize: 0,
        enabledPercentUpdate: true,
        percentToFinish: this.percentToFinish, // enabledPercentUpdate must to be true
        callback: function () {},
      };
    },
  },
};
</script>

<style scoped></style>
